export default __webpack_public_path__ + "static/media/success_icon.d756b833.svg";